// eslint-disable-next-line import/no-cycle
import { CommentsApiErrors } from './comments/api';

const checkStatus = (res) => {
  if (!res.ok) {
    throw new Error(res.status);
  }
  return res.json();
};

const checkApiSuccess = (json) => {
  if (!json?.success) {
    const errMsg = json?.errorCode ?? 'unknown';
    throw new Error(`'${CommentsApiErrors[errMsg] ?? 'desconocido'}'`);
  }
  return json;
};

const httpGet = (endpoint, onSuccess = (json) => json) => {
  return fetch(endpoint)
    .then(checkStatus)
    .then(checkApiSuccess)
    .then(onSuccess);
};

const httpPost = (endpoint, onSuccess = (json) => json, body = {}) => {
  // https://github.github.io/fetch/#request-body
  return fetch(endpoint,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
    .then(checkStatus)
    .then(checkApiSuccess)
    .then(onSuccess);
};

// Ver punto de corte en resources/sass/_misc.scss
const isMobile = matchMedia('(max-width: 768px)').matches;
const isTablet = matchMedia('(min-width: 768px) and (max-width: 1039px)').matches;

const currentMonth = new Date().getMonth() + 1;
const currentYear = new Date().getFullYear();

/**
 * Funcion helper para usar en el .catch de las llamadas a la Api
 * Ejemplo de uso:
 *
 * Usar desde una acción de vuex. Pasar como función del método .catch(err)
 *
 * await CommentsAPI.fetchComments(state.contentId, state.filters).catch(showError.bind(this));
 *
 */
function showError(err) {
  // FIXME: esto parece un hack pero who cares, ñapa tras ñapa, suma y sigue, son una tras otra
  // Si encuentras una manera de llamar a este método de una manera más limpia, adelante!
  this._vm.$toasted.global.commentError({ message: err.message });
}

function showConsoleError(err) {
  if (!err.message) {
    return console.error('Se ha producido un error al realizar la acción. Por favor, inténtelo más tarde.')
  }
  return console.error('Se ha producido un error: ', err. message, ' Por favor, inténtalo más tarde.')
}

export {
  httpGet,
  httpPost,
  isMobile,
  isTablet,
  currentMonth,
  currentYear,
  showError,
  showConsoleError,
};
